import { gridSize } from '@atlaskit/theme';
import styled from '@emotion/styled';

const SpinnerContainer = styled.div`
    margin-left: ${2 * gridSize()}px;
    width: ${3 * gridSize()}px;
`;

export default SpinnerContainer;
